"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableLoadingState = void 0;
const react_1 = require("react");
const useTableLoadingState = ({ requestVariables, isLoading, hasError = false, }) => {
    var _a;
    const requestKey = (_a = JSON.stringify(requestVariables)) !== null && _a !== void 0 ? _a : '';
    const [settledRequestKey, setSettledRequestKey] = (0, react_1.useState)(() => (isLoading ? undefined : requestKey));
    (0, react_1.useEffect)(() => {
        if (isLoading && !hasError)
            return;
        setSettledRequestKey(requestKey);
    }, [hasError, isLoading, requestKey]);
    const hasSettled = settledRequestKey === requestKey;
    const loading = !hasError && (isLoading || !hasSettled);
    return {
        loading,
        hasSettled,
    };
};
exports.useTableLoadingState = useTableLoadingState;
